import { t as e } from "../../chunks/index.es.wVhS2yfK.js";
import { Transforms as t } from "slate";
// lib/Factbox/lib/actionHandler.ts
var n = ({ editor: n, options: r }) => {
	let i = e.getSelectedText(n), a = r?.factboxNewTitle, o = typeof a == "string" ? a : "", s = crypto.randomUUID(), c = [{
		id: s,
		class: "block",
		type: "core/factbox",
		properties: {
			original_id: s,
			original_updated: (/* @__PURE__ */ new Date()).toISOString(),
			created: (/* @__PURE__ */ new Date()).toISOString()
		},
		children: [{
			id: crypto.randomUUID(),
			class: "text",
			type: "core/factbox/title",
			children: [{ text: o }]
		}, {
			id: crypto.randomUUID(),
			class: "block",
			type: "core/factbox/body",
			children: [{
				id: crypto.randomUUID(),
				class: "text",
				type: "core/text",
				children: [{ text: "" }]
			}]
		}]
	}], l = e.position(n) + +!i;
	e.insertAt(n, l, c), t.select(n, {
		anchor: {
			offset: o.length,
			path: [
				l,
				0,
				0
			]
		},
		focus: {
			offset: o.length,
			path: [
				l,
				0,
				0
			]
		}
	});
};
export { n as actionHandler };
